import request from '@/utils/request'


// 获取我的作品列表
export function getMusicList(data) {
  return request({
    url: '/api/album/mylist',
    method: 'post',
    data
  })
}

// 首页 获取作品专辑列表
export function getHomeMusicList(data) {
  return request({
    url: '/api/album/mylist',
    method: 'post',
    data
  })
}

// 首页 获取作品专辑列表
export function getAlbumList(data) {
  return request({
    url: '/api/album/get_user_album_list',
    method: 'post',
    data
  })
}

// 首页 获取作品单曲列表
export function getSingleList(data) {
  return request({
    url: '/api/album/get_user_music_list',
    method: 'post',
    data
  })
}

// 获取账单列表
export function getBillList(data) {
  return request({
    url: '/api/bill/spbill',
    method: 'post',
    data
  })
}

// 确认账单
export function confirmBill(data) {
  return request({
    url: '/api/bill/confirm',
    method: 'post',
    data
  })
}

// 账单详情
export function spBillDetail(data) {
  return request({
    url: '/api/bill/splist',
    method: 'post',
    data
  })
}

// 模糊查询歌曲
export function searchMusic(data) {
  return request({
    url: '/api/music/mysearch',
    method: 'post',
    data
  })
}

// 查询单曲信息
export function getMusicInfo(params) {
  return request({
    url: '/api/h5_album/music_info',
    method: 'get',
    params
  })
}

// 查询专辑信息
export function getAlbumMusicInfo(data) {
  return request({
    url: '/api/h5_album/album_info',
    method: 'post',
    data
  })
}

// 获取咨询列表
export function getNoticeList(data) {
  return request({
    url: '/api/cms/data/news',
    method: 'post',
    data
  })
}

// 获取咨询详情
export function getNoticeInfo(data) {
  return request({
    url: '/api/cms/data/news_info',
    method: 'post',
    data
  })
}
